import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import './printPreview.css'
import { OrientationContainer } from './'
import Header from "../Aside/Header";

export class PrintPreview extends Component {

    static propTypes = {
        print: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    }

    render() {
        const { print, close, t } = this.props

        return (
            <div className="print-preview">
                <Header
                    className='print-preview-header'
                    close={close}
                    title={t('visualizer:toolbar.left.print.preview.title')}
                />
                <div className="content">
                    <OrientationContainer />
                    <input onClick={close} type="button" className="btn secondary" value={t('visualizer:toolbar.left.print.preview.buttons.cancel')} />
                    <input onClick={print} type="button" className="btn primary" value={t('visualizer:toolbar.left.print.preview.buttons.print')} />
                </div>
            </div>

        )
    }
}

export default withTranslation()(PrintPreview)
